import React, { useState } from "react";
import "./mini-calendar.css";
import prevIcon from "../../assets/SVGs/prev-button.svg";
import nextIcon from "../../assets/SVGs/next-button.svg";
import { useTheme } from "../../utils/ThemeContext";

const MiniCalendar = () => {
  const { theme } = useTheme();
  const [currentDate, setCurrentDate] = useState(new Date());

  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const today = new Date();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const lastDayOfPrevMonth = new Date(year, month, 0);

  const daysInMonth = lastDayOfMonth.getDate();
  const daysInPrevMonth = lastDayOfPrevMonth.getDate();

  const firstDayIndex = firstDayOfMonth.getDay();
  const lastDayIndex = lastDayOfMonth.getDay();

  const dates = [];

  for (let i = firstDayIndex; i > 0; i--) {
    dates.push({
      day: daysInPrevMonth - i + 1,
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    dates.push({
      day: i,
      currentMonth: true,
      isToday:
        today.getDate() === i &&
        today.getMonth() === month &&
        today.getFullYear() === year,
    });
  }

  for (let i = 1; i < 7 - lastDayIndex; i++) {
    dates.push({
      day: i,
      currentMonth: false,
    });
  }

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  return (
    <div
      style={{
        backgroundColor: theme === "light" ? "#ffffff" : "rgb(35, 35, 35)",
      }}
      className="small-static-calendar-container">
      <div
        className="calendar-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
        {/* <div className="next-prev-buttons"> */}
        <button onClick={handlePrevMonth}>
          <img
            style={{
              filter: theme === "dark" ? "invert(0)" : "invert(1)",
              width: "24px",
              height: "24px",
            }}
            src={prevIcon}
            alt=""
          />
        </button>
        <span
          style={{ color: theme === "dark" ? "#ffffff" : "rgb(35, 35, 35)" }}>
          {currentDate.toLocaleString("default", { month: "long" })}{" "}
          <span style={{ color: theme === "dark" ? "#1e90ff" : "#1e90ff" }}>
            {year}
          </span>
        </span>
        <button onClick={handleNextMonth}>
          <img
            style={{
              filter: theme === "dark" ? "invert(0)" : "invert(1)",
              width: "24px",
              height: "24px",
            }}
            src={nextIcon}
            alt=""
          />
        </button>
        {/* </div> */}
      </div>
      <div
        style={{ color: theme === "dark" ? "#ffffff" : "rgb(35, 35, 35)" }}
        className="calendar-grid">
        {daysOfWeek.map((day) => (
          <div key={day} className="calendar-day">
            {day}
          </div>
        ))}
        {dates.map((date, index) => (
          <div
            style={{ color: theme === "dark" ? "#ffffff" : "rgb(35, 35, 35)" }}
            key={index}
            className={`calendar-date ${date.currentMonth ? "" : "disabled"} ${
              date.isToday ? "today" : ""
            }`}>
            {date.day}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniCalendar;
